import { getAuthorization } from 'controllers/controller';
import { getSkillsDensityStatsService } from 'services/dashboard/getSkillsDensityStats';

export const getSkillsDensityStats = async (jobId, last, talentStatus) => {
  const authorization = getAuthorization();

  const { data } = await getSkillsDensityStatsService(authorization, {
    jobId,
    last,
    talentStatus,
  });

  return data.response;
};

export const formatSkillsDensityStats = (response) => {
  const { data, labels } = response.reduce(
    (acc, curr) => {
      acc.labels.push(curr.skillName);
      acc.data.push(curr.skillDensity);

      return acc;
    },
    { data: [], labels: [] }
  );
  return { data, labels };
};
